/* stylelint-disable selector-class-pattern, max-nesting-depth, comment-empty-line-before, declaration-block-no-redundant-longhand-properties */
/**
 * @prop --wf-loyalty-button-padding-y: The padding on the y-axis for the inner content.
 * @prop --wf-loyalty-button-padding-x: The padding on the x-axis for the inner content.
 * @prop --wf-loyalty-button-border-radius: The border radius of the button.
 * @prop --wf-loyalty-caps-font-size: The font size of the button.
 * @prop --wf-loyalty-gold-100: The background color of the card.
 * @prop --wf-loyalty-grey-1000: The background color for the filled or hovered cta.
 * @prop --wf-grey-0: The color of the text for the filled and hovered cta.
 * @prop --wf-loyalty-highlight-color-red: The background color for the filled and hovered cta.
 */
:host {
    a {
        cursor: pointer;

        display: flex;
        justify-content: center;

        padding: var(--wf-loyalty-button-padding-y, 10px)
            var(--wf-loyalty-button-padding-x, 12px);

        border-radius: var(--wf-loyalty-button-border-radius, 2px);
        border: 1px solid var(--wf-grey-1000, #000);

        font-size: var(--wf-loyalty-caps-font-size, 14px);
        font-weight: 500;
        color: var(--wf-grey-1000, #000);
        text-decoration: none;

        &:hover {
            background: var(--wf-grey-1000, #000);
            color: var(--wf-gold-100, #f2e6d8);
        }

        &.filled {
            background: var(--wf-grey-1000, #000);
            color: var(--wf-grey-0, #fff);

            &:hover {
                background: var(--wf-loyalty-highlight-color-red, #ea5659);
                border: 1px solid var(--wf-loyalty-highlight-color-red, #ea5659);
            }
        }
    }
}
